import taxonomyQueries from './taxonomyQueries'
import variableQueries from './variableQueries'

export default function createGetProductsQuery() {
  const taxonomyQueriesString = Object.values(taxonomyQueries).join('\n')
  const variableQueriesString = Object.keys(variableQueries).map(key => `${key}: variable (name: "${variableQueries[key]}")`).join('\n')

  return `query getProducts {
      products(limit: 0, active: true, allowincart: true) {
        ... on ContentInterface {
          id
          title
          created
          modified
          status
          featured
          sticky
          path
          order
          access
          type
        }
        ... on ProductInterface {
          producttype
          productsettings {
            discountgroup,
            managestock,
            sku,
            stock,
            price,
            prices {
              base_price,
              unit_price
            },
            allowincart,
            showincatalog,
            cartmultiple,
            customqty
          }
          abstract
          images {
            image {
              filepath,
              filesize,
              filemime,
              preset,
              filestorename
            }
          }
        }
        ...on GenericProductType {
          seo {
            titletag
            metadesctag
            path
          }
        }
        ...on POSProduct {
          posProductCategory: category
          seo {
            titletag
            metadesctag
            path
          }
        }
        ... on POSFoodProduct {
          posFoodProductCategory: category
          seo {
            titletag
            metadesctag
            path
          }
        }
        ... on POSModifierProduct {
          posModifierProductCategory: category
          seo {
            titletag
            metadesctag
            path
          }
        }
        ... on SomnambulistSelection {
          seo {
            titletag
            metadesctag
            path
          }
        }
        ... on VCShopProduct {
          pack_size
          shopProductCategory: category
          body
          seo {
            titletag
            metadesctag
            path
          }
          award_winner, bottlesize, wineproductrrp: rrp, unit_of_sale
          reviews { title, subtitle, review, points, date }, awards { title, subtitle, level, year }, features { title, text },
          related_products { delta, product { id, title } }
        }
        ... on WineProduct {
          pack_size
          body
          seo {
            titletag
            metadesctag
            path
          }
          award_winner, varietal, bottlesize, vintage, winebody, wine_type, sweetness, series, seo { path }, wineproductrrp: rrp, faq_categories, unit_of_sale
          tasting_notes { title, text }, wine_making { title, text }, technical_notes { title, text }, reviews { title, subtitle, review, points, date }, awards { title, subtitle, level, year }, features { title, text },
          prev_tasting_notes { data{title}, preview_url, filestorename, filepath, preset }
          wine_club, max_cart, max_club, min_club
          related_products { delta, product { id, title } }
        }
        ... on WineGlassProduct {
          seo {
            titletag
            metadesctag
            path
          }
          varietal,
          wine_type,
          sweetness,
          series,
          wineglassproductrrp: rrp,
          unit_of_sale
        }
        ... on WineTastingProductType {
          body
          seo {
            titletag
            metadesctag
            path
          }
          unit_of_sale
        }
      }
      ${taxonomyQueriesString}
      ${variableQueriesString}
  }`
}
